import { render, staticRenderFns } from "./FolderUpload.vue?vue&type=template&id=15a60cc5"
import script from "./FolderUpload.vue?vue&type=script&lang=js"
export * from "./FolderUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports